import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=573b928a&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=573b928a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b928a",
  null
  
)

export default component.exports